<template>
	<div class="goods-info-body">
		<div class="title-box">
			<div class="title0" style="flex:2;"></div>
			<div class="title1 title" style="flex:4;">
				商品名称
			</div>
			<div class="title0 title" style="flex:3;">
				属性
			</div>
			<!-- <div class="title0 title" style="flex:3;">
				单价
			</div> -->
			<div class="title0 title" style="flex:2;">
				实际单价
			</div>
			<div class="title0 title" style="flex:5;">
				退货数量
			</div>
			<div class="title0 title" style="flex:2;">
				小计
			</div>

		</div>
		<div class="row-box" v-for="item in goodData" :key='item.goodsId'>
			<div class="row row0" style="flex:3;">
				<div class="img-box">
					<img v-if="item.imgurl === ''" src="~/images/img/no-goods-img.png">
					<w-image v-else :src="item.imgurl"></w-image>
					<img src="~/images/icon/presentation-icon.png" alt="" class="goods-flag-icon" v-if="item.giftflag" :class="{'no-new': item.giftflag}">
				</div>
			</div>
			<div class="row row1" style="flex:3;">
				<el-tooltip class="item" effect="dark" placement="top">
					<div slot="content">{{item.pname}}</div>
					<div class="name-box">{{item.pname}}</div>
				</el-tooltip>
			</div>
			<div class="row row0" style="flex:3;">
				{{item.spec}}
			</div>
			<!-- <div class="row row0" style="flex:3;">
				￥{{$fxUtils.toFixedSHW(item.price, 2)}}
			</div> -->
			<div class="row row0" style="flex:2;">
				￥{{$fxUtils.toFixedSHW((item.refundmoney/item.itemquantity) === Infinity ? 0 : (item.refundmoney/item.itemquantity), 2)}}
			</div>
			<div class="row row0" style="display: flex;flex-flow: column;align-items: start;justify-content: center;flex: 5;" v-if="canEdit">
				<div>
					<el-input-number @change="numChange(item.itemquantity)" size="mini" :min="0"  v-model="item.itemquantity" :step="1"></el-input-number>
					<span v-if="item.useunitflag === 1">{{item.punit}}</span>
					<span style="margin-left:10px;" v-if="item.useunitflag === 1">最大可能退{{refundmaxquantity}}{{item.punit}}</span>
				</div>
				<div v-if="item.useunitflag === 1 && matchbillcenterflag === 1">
					<el-input-number style="margin-top: 10px;" @change="numChange1(item.refundassistquantity)" size="mini" :min="0"  v-model="item.refundassistquantity" :step="1"></el-input-number>
					<span>{{item.assistunit}}</span>
					<span style="margin-left:10px;">最大可能退{{refundmaxassistquantity}}{{item.assistunit}}</span>
				</div>
			</div>
			<div class="row row0" style="display: flex;flex-flow: column;align-items: start;justify-content: center;flex: 5;" v-else>
				<div style="margin-left: 30px;"><span>x{{item.itemquantity}}</span><span v-if="item.useunitflag === 1 && matchbillcenterflag === 1">{{item.punit}}</span></div>
				<div style="margin-left: 30px;" v-if="item.useunitflag === 1 && matchbillcenterflag === 1"><span>x{{item.refundassistquantity}}</span><span>{{item.assistunit}}</span></div>
			</div>
			<div class="row row0" style="position: relative;flex: 2;">
				<span>￥{{$fxUtils.toFixedSHW(item.refundmoney, 2)}}</span>
			</div>
		</div>
		<div class="total">
			<div class="summary">
				<div><span>应退金额：</span>￥{{$fxUtils.toFixedSHW(initialfinalmoney, 2)}} <i v-if="orderstatusName === '退货完成' && autoflag" @click="openDetailDialog">明细</i></div>
				<div><span>已退金额：</span>￥{{$fxUtils.toFixedSHW(backmoney, 2)}}</div>
				<div><span>未退金额：</span>￥{{$fxUtils.toFixedSHW(totalmoney, 2)}} <i v-if="orderstatusName !== '待处理' && orderstatusName !== '已同意'" @click="reload">刷新</i></div>
			</div>
		</div>
		<el-dialog title="明细" class="confirm-dialog" top='60px' @close="cancelDetailDialog" :visible.sync="detailDialogFlag" width='1025px' :close-on-click-modal="false">
			<el-table
				:data="tableData"
				:header-cell-style="{background:'#F7F8FA', color:'#333333', fontSize:'14px', fontWeight:'bold'}">
				<el-table-column
					width="200px"
					prop="orderChildOrdernumber"
					label="子退单号"
					align="center">
				</el-table-column>
				<el-table-column
					width="120px"
					prop="orderChildSourcetype"
					label="子退单来源"
					align="center">
					<template slot-scope='scope'>
						<span v-if="scope.row.orderChildSourcetype === 0">待付款</span>
						<span v-if="scope.row.orderChildSourcetype === 1">待接单</span>
						<span v-if="scope.row.orderChildSourcetype === 2">待发货</span>
						<span v-if="scope.row.orderChildSourcetype === 3">待收货</span>
						<span v-if="scope.row.orderChildSourcetype === 4">已完成</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="money"
					width="120px"
					label="退款金额"
					align="center">
					<template slot-scope='scope'>
						<span>{{$fxUtils.toFixedSHW(scope.row.money, 2)}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="childNegativeOrderNumber"
					label="抵消子订单号"
					align="center">
					<template slot-scope='scope'>
						<div v-for='(item,index) in scope.row.detailList' :key='index'>
							<span v-if="item.paymode === 5" style="margin-right: 5px;color:var(--fx-primary-color);text-decoration: underline;cursor: pointer;" @click="btnClick(item.serialnumber)">{{item.serialnumber}}</span>
							<span v-if="item.paymode !== 5" style="margin-right: 5px;">{{item.serialnumber}}</span>
							<span v-if="item.paymode === 0">线下</span>
							<span v-if="item.paymode === 2">微信</span>
							<span v-if="item.paymode === 5">抵消</span>
							<span style="margin-left: 5px;">￥{{$fxUtils.toFixedSHW(item.money, 2)}}</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'goodsInfo',
	props: {
		goodData: Array,
		resData: Object,
		deliveryData: Object,
		autoflag: Boolean,
		orderstatusName: String,
		canEdit: Boolean,
		matchbillcenterflag: Number
	},
	data () {
		return {
			orderChildNumber: '',
			tabParams: {},
			orderParams: {},
			tableData: [],
			detailDialogFlag: false,
			isMore: false,
			punit: null,
			number: null,
			initialfinalmoney: 0,
			totalmoney: 0,
			backmoney: 0,
			refundmaxquantity: 0,
			refundmaxassistquantity: 0
			// total: null
		}
	},
	watch: {
		goodData: {
			handler (val) {
				console.log(val)
				let a = val
				this.number = 0
				// this.total = a[0].finalprice
				this.initialfinalmoney = this.resData.initialfinalmoney
				this.totalmoney = this.resData.totalmoney
				this.backmoney = this.resData.backmoney
				if (a.length === 1) {
					this.isMore = false
					for (let i = 0; i < a.length; i++) {
						this.number = this.number + a[i].itemquantity
						this.punit = a[i].punit
					}
				} else {
					this.isMore = true
					for (let i = 0; i < a.length; i++) {
						this.number = this.number + a[i].itemquantity
						this.punit = a[i].punit
					}
				}
			}
		},
		canEdit: {
			handler (val) {
				console.log(val)
				if (val) {
					this.getRefundMaxQuantity()
				}
			}
		}
	},
	methods: {
		btnClick (num) {
			this.orderParams = {}
			this.tabParams = {}
			this.tabParams.organid = this.organid
			this.tabParams.isSellerpull = this.deliveryData.isSellerpull
			this.tabParams.sellerShopId = this.deliveryData.sellerShopId
			this.tabParams.orderStatus = +this.deliveryData.billState
			this.orderParams.buypullstate = this.deliveryData.buypullstate
			this.orderParams.differ = this.deliveryData.differ
			this.orderParams.orderId = this.deliveryData.orderId
			this.orderParams.statusId = this.deliveryData.statusId
			switch (this.deliveryData.billState) {
			case '0':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '1':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '2':
				if (this.deliveryData.isSellerpull) {
					this.tabParams.active = '备货中'
					this.orderParams.billState = '备货中'
				} else {
					this.tabParams.active = '待付款'
					this.orderParams.billState = '待付款'
				}
				break
			case '3':
				this.tabParams.active = '待收货'
				this.orderParams.billState = '待收货'
				break
			case '4':
				this.tabParams.active = '已完成'
				this.orderParams.billState = '已完成'
				break
			case '5':
				this.tabParams.active = '已取消'
				this.orderParams.billState = '已取消'
				break
			}
			if (this.tabParams.orderStatus === 0) {
				this.statusCode = '07_0001_0001_00'
			} else if (this.tabParams.orderStatus === 1) {
				this.statusCode = '07_0001_0004_00'
			} else if (this.tabParams.orderStatus === 2) {
				if (this.tabParams.isSellerpull === true) {
					this.statusCode = '07_0001_0010_00'
				} else {
					this.statusCode = '07_0001_0007_00'
				}
			} else if (this.tabParams.orderStatus === 3) {
				this.statusCode = '07_0001_0013_00'
			} else if (this.tabParams.orderStatus === 4) {
				this.statusCode = '07_0001_0016_00'
			} else if (this.tabParams.orderStatus === 5) {
				this.statusCode = '07_0001_0019_00'
			}
			this.getAuthority(this.statusCode, num)
		},
		getAuthority (val, num) {
			let params = {
				pId: '07_0001_0000_00'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					this.flag = false
					for (let i = 0; i < a.length; i++) {
						if (a[i] === val) {
							console.log(a[i])
							this.flag = true
						}
					}
					if (this.flag) {
						window.sessionStorage.setItem('tabInfo', JSON.stringify(this.tabParams))
						window.sessionStorage.setItem('orderInfo', JSON.stringify(this.orderParams))
						window.sessionStorage.setItem('orderChildNumber', num)
						this.$fxEventBus.$emit('setMenu', '6-1')
						this.$router.push('/main/orderDetail')
					} else {
						this.$message.error('没有订单权限，不能进入订单详情界面')
					}
				}
			})
		},
		reload () {
			let params = {
				refundId: this.deliveryData.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/payback/refresh`,
				data: params
			}).then(res => {
				this.$parent.getInfo()
				if (res.result === true) {
					this.$message.success('钱款已经退回您的银行卡，如未到账，您可以再次点击帮助退款！')
				} else {
					this.$message.success('退款失败！')
				}
			})
		},
		openDetailDialog () {
			let params = {
				refundId: this.deliveryData.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/orderchildlist`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data
					this.detailDialogFlag = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelDetailDialog () {
			this.detailDialogFlag = false
		},
		getRefundMaxQuantity () {
			let params = {
				oiid: this.goodData[0].oiid,
				oipid: this.goodData[0].oipid,
				orderid: this.goodData[0].orderid,
				refundid: this.goodData[0].refundid,
				price: this.goodData[0].price,
				realmoney: this.goodData[0].refundmoney,
				realquantity: this.goodData[0].itemquantity
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/refundMaxQuantity`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.refundmaxquantity = res.data.refundmaxquantity
					this.refundmaxassistquantity = res.data.refundmaxassistquantity
				}
			})
		},
		updateRefundQuantity () {
			return new Promise((resolve, reject) => {
				console.log(this.deliveryData)
				this.goodData.forEach(item => {
					let itemPrice = item.itemquantity * item.price
					item.refundMoney = this.$fxUtils.toFixedSHW(itemPrice, 2)
				})
				let detailInfos = this.goodData.map(e => {
					return {
						oipid: e.oipid,
						oiid: e.oiid,
						refundquantity: e.itemquantity,
						refundassistquantity: e.refundassistquantity,
						refundDetailId: e.rdid,
						refundmoney: e.refundMoney
					}
				})
				let params = {
					refundid: this.goodData[0].refundid,
					orderid: this.goodData[0].orderid,
					detailInfos
					// oiid: this.goodData[0].oiid,
					// oipid: this.goodData[0].oipid,
					// refundDetailId: this.goodData[0].rdid,
					// itemquantity: this.goodData[0].itemquantity,
					// assistQuantity: this.goodData[0].refundassistquantity,
					// refundMoney
				}
				console.log(params)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/refundorder/saveRefundQuantity`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.$message.success('保存成功！')
					} else {
						this.$message.error(res.msg)
						return false
					}
					resolve(res)
				})
			})
		},
		numChange (val) {
			console.log('itemquantity', val)
		},
		numChange1 (val) {
			console.log('refundassistquantity', val)
		}
	}
}
</script>

<style lang="stylus" scoped>
.goods-info-body {
	margin-top :10px;
	font-size: 14px
	.title-box{
		display :flex;
		flex-direction :row;
		height :40px;
		background-color :#F7F8FA;
		align-items: center
		.title{
			display :flex;
		}
		.title0{
			// flex :2;
			box-sizing :border-box;
			padding :0px 10px;
		}
		.title1{
			box-sizing :border-box;
			padding :0px 10px;
		}
	}
	.row-box{
		display :flex;
		flex-direction :row;
		overflow-x :hidden;
		align-items: center;
		.row{
			height :80px;
			display :flex;
			align-items :center;
			justify-content :flex-start;
			border-bottom :1px solid #EDEFFC;
			img{
				width :60px;
				height :60px;
				margin:0 auto;
			}
		}
		.row0{
			box-sizing :border-box;
			flex:5;
			position: relative;
			// padding :0px 10px;
			.img-box {
				position: relative;
				width: 60px;
				height: 60px;
				margin-left: 40px
				position: relative;
				img {
					display: inline-block;
					width: 100%;
					height: 100%;
				}
				.goods-flag-icon {
					width: 24px;
					height: 24px;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
		}
		.row1{
			box-sizing :border-box;
			flex:4;
			padding :0px 10px;
		}
		.name-box{
			width :100%;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			max-height :40px;
			line-height :20px;
			text-align: left;
		}
	}
	.total{
		display flex;
		justify-content flex-end;
	}
	.summary {
		color: #333333
		font-size: 14px
		-webkit-box-orient: vertical
		flex-direction: column
		-webkit-box-pack: end
		-ms-flex-pack: end
		margin: 20px 0
		text-align: left
		line-height: 32px
		span {
			display: inline-block
			width: 90px
			text-align: right
			padding-right: 10px;
		}
		i {
			color: var(--fx-primary-color)
			text-decoration: underline
			cursor: pointer
			padding-left: 11px
		}
	}
}
</style>
<style lang="stylus">
.confirm-dialog{
	.el-dialog__header{
		text-align :left
	}
	.el-dialog__body{
		padding : 10px 10px 20px 10px;
	}
}
</style>
